import * as React from "react"
import { cn } from "src/utils/cn"
import { Label } from "src/components/ui/label"

// Minimal react-hook-form compatible form primitives
// These match the shadcn/ui Form API surface

const FormFieldContext = React.createContext({})
const FormItemContext = React.createContext({})

// FormField wraps react-hook-form's Controller
// Usage: <FormField control={form.control} name="x" render={({field})=><FormItem>...</FormItem>} />
function FormField({ ...props }) {
  return (
    <FormFieldContext.Provider value={{ name: props.name }}>
      {props.render({ field: props.field, fieldState: props.fieldState })}
    </FormFieldContext.Provider>
  )
}

const FormItem = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <FormItemContext.Provider value={{}}>
      <div ref={ref} className={cn("space-y-1.5", className)} {...props} />
    </FormItemContext.Provider>
  )
})
FormItem.displayName = "FormItem"

const FormLabel = React.forwardRef(({ className, ...props }, ref) => (
  <Label ref={ref} className={cn("text-sm font-medium text-slate-700", className)} {...props} />
))
FormLabel.displayName = "FormLabel"

const FormControl = React.forwardRef(({ ...props }, ref) => (
  <div ref={ref} {...props} />
))
FormControl.displayName = "FormControl"

const FormDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p ref={ref} className={cn("text-[12px] text-slate-500", className)} {...props} />
))
FormDescription.displayName = "FormDescription"

const FormMessage = React.forwardRef(({ className, children, ...props }, ref) => {
  if (!children) return null
  return (
    <p ref={ref} className={cn("text-[12px] font-medium text-red-500", className)} {...props}>
      {children}
    </p>
  )
})
FormMessage.displayName = "FormMessage"

export { FormField, FormItem, FormLabel, FormControl, FormDescription, FormMessage }
